/**
 * 底部 tab 定義（**唯一來源**）—— id ／ i18n key ／ icon ／ 路由
 *
 * ⚠️ 路由屬產品專屬 → 依 R6 屬「普通共用檔」（同 family-tree `utils/tabRoutes.ts` 同理），
 *    唔做成模組（冇得唔提產品名去描述佢）。
 */
import type { NavIcon } from '@coeldery/bottom-nav';

export interface NavTab {
  id: string;
  labelKey: string;
  icon: NavIcon;
  /** app 路由 */
  path: string;
}

/** 5 個 tab（次序 ＝ 畫面次序）：優惠／資訊／我的卡／廣告／設定 */
export const NAV_TABS: readonly NavTab[] = [
  { id: 'benefits', labelKey: 'tab.benefits', icon: 'benefits', path: '/member/benefits' },
  { id: 'news', labelKey: 'tab.news', icon: 'news', path: '/member/news' },
  { id: 'cards', labelKey: 'tab.cards', icon: 'card', path: '/member/cards' },
  { id: 'ads', labelKey: 'tab.ads', icon: 'ads', path: '/member/ads' },
  { id: 'settings', labelKey: 'tab.settings', icon: 'setting', path: '/member/settings' },
];
